import React from 'react';
import { Dialog, DialogTitle, DialogContent, Box, Typography } from '@mui/material';
import { Timeline, TimelineLayout } from 'framework/ui/timeline';
import useEmployeeFeedbacksService from 'domain/people/employee/feedbacks/EmployeeFeedbacksService';
import useFeedbackAboutMeRegistry from 'domain/people/employee/feedbacks/FeedbackAboutMeRegistry';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

interface AboutMeFeedbackModalProps {
  open: boolean;
  onClose: () => void;
}

const AboutMeFeedbackModal: React.FC<AboutMeFeedbackModalProps> = ({ open, onClose }) => {
  const { search } = useEmployeeFeedbacksService();
  const feedbackRegistry = useFeedbackAboutMeRegistry();
  const scrollableContainerRef = React.useRef<HTMLDivElement>(null);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h3" color="textPrimary">
            All feedback about me
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ height: '70vh', padding: 3, overflow: 'auto' }} ref={scrollableContainerRef}>
        <Timeline
          registries={[feedbackRegistry] as any}
          getDataMethod={request => search(request)}
          scrollableContainer={scrollableContainerRef}
          useWindow={false}
        >
          <TimelineLayout noEntriesMessage="No feedback about my work yet." />
        </Timeline>
      </DialogContent>
    </Dialog>
  );
};

export default AboutMeFeedbackModal;
